import PublicRoute from "shared/authorization/PublicRoute";
import Layout from "shared/components/Layout/Public";
import { PATHS } from "utils/constants";

import ErrorPage from "./Error";
import Redirection from "./Redirection";
import ResetPassword from "./ResetPassword";
import SentEmail from "./SentEmail";
import SingIn from "./SignIn";
import SingUp from "./SignUp";
import VerifyEmail from "./VerifyEmail";
import {PrivacyPolicyDocument} from "./PrivacyPolicyDocument";

const routes = [
  {
    path: PATHS.AUTH.SIGN_IN,
    exact: true,
    component: Layout(SingIn),
  },
  {
    path: PATHS.AUTH.REDIRECTION,
    component: Layout(Redirection),
  },
  {
    path: PATHS.AUTH.SIGN_UP,
    exact: true,
    component: Layout(SingUp),
  },
  {
    path: PATHS.AUTH.VERIFY_EMAIL,
    exact: true,
    component: Layout(VerifyEmail),
  },
  {
    path: PATHS.AUTH.RESET_PASSWORD,
    exact: true,
    component: Layout(ResetPassword),
  },
  {
    path: PATHS.AUTH.SENT_EMAIL,
    exact: true,
    component: Layout(SentEmail),
  },
  {
    path: PATHS.ERROR,
    exact: true,
    component: ErrorPage,
  },
  {
    path: PATHS.PRIVACY_POLICY,
    exact: true,
    component: PrivacyPolicyDocument
  }
];

export default routes.map(({ component, ...rest }) => {
  return {
    component: () =>
      PublicRoute({
        component,
      }),
    ...rest,
  };
});
